import {Grid} from "ag-grid-community";

function initGridForInfiniteScrolling(domElement,finalOptions){
	// Add a listener to get more rows when near the end of the dataset
	finalOptions.onBodyScroll = getRowsIfNeeded;
	finalOptions.debounceVerticalScrollbar = true;

	new Grid(domElement, finalOptions);

	// Add infinite scrolling methods
	finalOptions._getMoreRows = getMoreRows;
	finalOptions._refresh = refresh;
}

/**
 * Gets more rows from the endpoint and adds it to the current rows
 */
function getMoreRows() {
	// noinspection JSUnresolvedVariable
	if (this._fetchingRows) {
		// Prevent multiple simultaneous calls
		return
	}

	this._fetchingRows = true;

	if(!this._skipLoadingOverlay){
		this.api.showLoadingOverlay();
	}

	const startRow = this._rows.length;

	this._getRows(startRow).then(data => {
		this.api.hideOverlay();
		// noinspection JSUnresolvedVariable
		if (!data.rows || (data.rows.length === 0 && data.lastRowIndex === 0)) {
			// Display overlay if no data was returned
			this.api.showNoRowsOverlay();
			this._totalRows = 0;
			this._updateFooter();
		} else {
			// Add them to the grid...
			this.api.applyTransaction({
				add: data.rows,
			});
			// ... and to our copy
			this._rows = this._rows.concat(data.rows)

			// Update total rows
			// noinspection JSUnresolvedVariable
			this._totalRows = data.lastRowIndex;

			this._updateFooter();
		}

		if (this._afterSuccessCallback) {
			this._afterSuccessCallback();
		}
	}).catch(e => {
		//TODO: Set failure handler
		console.log(e);
		alert('Error retrieving rows');
	}).finally(() => {
		this._fetchingRows = false;
	})
}

/**
 * Gets more rows if the scrollbar is near the end of the container and there
 * are more rows still on the server
 *
 * @return {boolean}
 */
function getRowsIfNeeded() {
	// We don't need more rows if we don't even have rows
	if (this._rows.length === 0)
		return false;

	const gridBody = this._domElement.querySelector('.ag-body-viewport');
	const scrollPosition = gridBody.scrollTop;
	const maxScrollPosition = gridBody.scrollHeight - gridBody.clientHeight;

	const gridIsNearOrAtTheEndOfContainer = scrollPosition > (maxScrollPosition * 0.8);

	const gotAllRows = this._rows.length >= this._totalRows;

	if (gridIsNearOrAtTheEndOfContainer && !gotAllRows) {
		this._getMoreRows();
	}
}

/**
 * Refreshes the infinite scrolling grid by clearing
 * the rows and fetching new ones from the start
 */
function refresh() {
	this._rows = [];
	this.api.setRowData(this._rows);
	this._getMoreRows();
}

export {initGridForInfiniteScrolling}
